import React, { useState, useEffect, useRef } from 'react';
import TreeviewTable from '../components/treeviewTable.js'; // Создадим этот компонент позже
import { Loading } from '../components/loading.js';
import { Turl } from '../components/tUrl.js'
import { formatIntegerWithCommas, formatNumberWithCommas } from '../components/formatIntegerWithCommas.js';
import { t } from 'ttag';
import '../css/PartnersBlock.css'; // Создайте этот CSS файл
import { mixpanel } from '../components/mp.js';

// Telegram Mini Apps API (доступен глобально в Mini Apps)
const tg = window.Telegram ? window.Telegram.WebApp : null;

function PartnersBlock({ handlesetIndex, recData }) {
    const [mData, setmData] = useState(null);
    const hasFetchedData = useRef(false); // Ref для отслеживания первого вызова

    useEffect(() => {
        const getAfilate = async () => {
            hasFetchedData.current = true;
            try {
                const _userData = tg ? tg.initData : null;
                let userData = { initData: _userData }

                if (userData) {
                    const response = await fetch(Turl + '/api/afilate2', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(userData)
                    });

                    if (!response.ok) {
                        throw new Error(`HTTP error! Status: ${response.status}`);
                    }
                    let rd = await response.json();

                    setmData(rd)

                } else {
                    console.warn("Telegram user data not available.");
                }

            } catch (error) {
                console.error('Authentication error:', error);
            }
        };

        if (!mData && !hasFetchedData.current) {
            getAfilate();
        }
    }, [mData]);

    if (!mData)
        return <Loading />;
    hasFetchedData.current = false;

    return (
        <div className="p-container">

            {/* --- Блок 2: Статистика --- */}
            <div className="p-main-block p-stats-container">
                <div className="p-stat-item">
                    <span className="p-stat-label">{t`Your partners`}</span>
                    <span className="p-stat-value">{formatIntegerWithCommas(mData.inentr)}</span>
                </div>
                <div className="p-stat-item">
                    <span className="p-stat-label">{t`Your levels`}</span>
                    <span className="p-stat-value">{mData.levels}</span>
                </div>
                <div className="p-stat-item">
                    <span className="p-stat-label">{t`Total partners`}</span>
                    <span className="p-stat-value">{formatIntegerWithCommas(mData.inentrt)}</span>
                </div>
                <div className="p-stat-item">
                    <span className="p-stat-label">{t`Referral profit`}</span>
                    <span className="p-stat-value profit">{formatNumberWithCommas(recData.ref_profit || 0, 4)} USDT</span>
                </div>
            </div>

            {/* --- Блок 3: Рефералы (Таблица) --- */}
            <div className="p-main-block">
                <div className="p-block-title">{t`Referrals`}</div>
                <TreeviewTable data={mData.treeData} />
            </div>
        </div>
    );
}

export { PartnersBlock };